import { render, staticRenderFns } from "./CustomizedMessage.vue?vue&type=template&id=e64a22e4&"
import script from "./CustomizedMessage.vue?vue&type=script&lang=js&"
export * from "./CustomizedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports